var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 34,
    width: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34c9.389 0 17-7.611 17-17S26.389 0 17 0 0 7.611 0 17s7.611 17 17 17zm-1.395-16.235L9.041 9h5.06l4.302 5.746L23.729 9h1.486l-6.148 6.634L26 24.892h-5.059l-4.672-6.24-5.782 6.24H9zm-2.054-7.671h-2.323L21.49 23.798h2.324z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social--twitter-f4fedc2c53caa18a2f4f80afc485b6f3.svg";
export { SvgIconSocialTwitter as Component };